/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { SELECTED_SUBTOPIC_CHANGED } from '../data/actionTypes';
import { selectIsFetchingTopics } from '../data/loading/slice';
import { MAX_SUBTOPICS, TOPIC_CLUSTERS_DASHBOARD_LINK, TopicTypes } from '../data/topicEditor/constants';
import { selectSelectedSubtopicId } from '../data/topicEditor/slice';
import { selectSubtopicDropdownOptions } from '../data/topics/slice';
import { fetchTopics } from '../data/topics/thunks';
import { useDispatch, useSelector } from '../store';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SubtopicDropdown = ({
  selectedClusterId,
  onOpenCreateTopicDialog
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTopics({
      clusterId: selectedClusterId
    }));
  }, [dispatch, selectedClusterId]);
  const isFetchingTopics = useSelector(selectIsFetchingTopics);
  const selectedSubtopicId = useSelector(selectSelectedSubtopicId);
  const options = useSelector(selectSubtopicDropdownOptions);
  const canCreateSubtopic = options.length < MAX_SUBTOPICS;
  const handleSubtopicChange = event => {
    const {
      value
    } = event.target;
    dispatch({
      type: SELECTED_SUBTOPIC_CHANGED,
      payload: {
        selectedSubtopicId: value
      }
    });
  };
  if (isFetchingTopics) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 100
    });
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.label"
    }),
    "data-test-id": "topic-editor-subtopic-dropdown",
    children: /*#__PURE__*/_jsx(UISelect, {
      minimumSearchCount: 0,
      options: options,
      value: selectedSubtopicId,
      onChange: handleSubtopicChange,
      dropdownFooter: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(UITooltip, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.footer.maxTopicLimitTooltip"
            }),
            disabled: canCreateSubtopic,
            children: /*#__PURE__*/_jsx(UIButton, {
              disabled: !canCreateSubtopic,
              use: "link",
              onClick: () => {
                onOpenCreateTopicDialog(TopicTypes.SUBTOPIC);
              },
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.footer.createTopic"
              })
            })
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-y-2",
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "link",
            external: true,
            href: TOPIC_CLUSTERS_DASHBOARD_LINK,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.footer.editTopics"
            })
          })
        })]
      }),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.subtopicDropdown.placeholder"
      }),
      searchable: true
    })
  });
};